import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import MarketsList from '../../MarketsList'

const LocationsWrapper = styled.div`
  width: 100%;
  padding: 72px 88px;
  max-width: 1600px;

  ${mq('max', '768px')} {
    padding: 50px 16px;
  }

  .location-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
`

const LocationsSection = () => (
  <LocationsWrapper>
    <MarketsList />
  </LocationsWrapper>
)

export default LocationsSection
